/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guides_Retrieved_MessageInputs */



/**
* | output |
* | --- |
* | "Style guides retrieved successfully" |
*
* @param {Iframe_Remote_Style_Guides_Retrieved_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guides_retrieved_message = /** @type {((inputs?: Iframe_Remote_Style_Guides_Retrieved_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guides_Retrieved_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guides de style recuperes avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguides erfolgreich abgerufen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guide di stile recuperate con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководства по стилю успешно получены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guías de estilo recuperadas con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功检索到样式指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドが正常に取得されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली मार्गदर्शिकाएँ सफलतापूर्वक प्राप्त कर ली गईं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guias de estilo recuperados com sucesso")
	return /** @type {LocalizedString} */ ("Style guides retrieved successfully")
});